export default {"src":"/_next/static/media/crossWithPaw_24.6770ce87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};